
export const UNLIMITED_SYSTEM_SUBSCRIPTIONS = -1;
export const UNLIMITED_DIAGNOSTIC_SUBSCRIPTIONS = -1;
export const HIDE_DIAGNOSTIC_SUBSCRIPTIONS = -2;

// Subscription Type Constants:
export const SUBSCRIPTION_TYPE_SCREENER: number = 0;
export const SUBSCRIPTION_TYPE_DIAGNOSTIC: number = 1;
export const SUBSCRIPTION_TYPE_INTERVENTION: number = 2;
export const SUBSCRIPTION_TYPE_DIAGNOSTIC_MID: number = 3;
export const SUBSCRIPTION_TYPE_DIAGNOSTIC_POST: number = 4;
